import React from "react";
import LoginLink from "./LoginLink";
import GetPriceByEmail from "./GetPriceByEmail";
import Standard from "../Price";
import { VariantProps } from ".";
export default ({
  selectedProduct
}: VariantProps) => <div className="map map-override mapP">
    <Standard price={selectedProduct.price.price} unitOfMeasure={selectedProduct.unitOfMeasure} textSize="small" />
    <p className="price enter-email">
      {selectedProduct.showBelowMinimumAdvertisedPriceForLoggedInCustomers ? <>
          <LoginLink>Login</LoginLink>
          {" or enter your email "}
          <br />
          {" for current pricing."}
        </> : <>
          {"Enter your email for "}
          <br />
          current pricing.
        </>}
    </p>
    <div className="input-append">
      <GetPriceByEmail itemNumber={selectedProduct.itemNumber} />
    </div>
  </div>;